import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

export default function MusicPlayer() {
  const audioRef = useRef(new Audio("/music/baul.mp3"));
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(!playing);
  };

  return (
    <button
      onClick={togglePlay}
      className="fixed bottom-6 right-6 bg-amber-700 text-white rounded-full p-4 shadow-lg hover:bg-amber-800 transition"
    >
      {playing ? <Pause /> : <Play />}
    </button>
  );
}
